<template>
  <!-- Admin nav drawer -->
  <v-navigation-drawer
    v-if="(isAdmin || canViewAdmin) && !limitedUser"
    v-model="adminDrawer"
    fixed
    temporary
    dark
    class="admin-drawer"
  >
    <!-- {{ isDev() }} -->
    <v-list class="pa-1">
      <v-list-item tag="div">
        <v-list-item-avatar>
          <v-img
            v-if="profileImage && profileImage.imageURL"
            :src="`${profileImage.imageURL}?w=200&h=200&fit=crop`"
            alt="User Profile Image"
            :lazy-src="lazyProfileImage"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-if="displayName" class="username">
            {{ displayName }}
          </v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon @click.stop="changeAdmin">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>

    <v-list class="pt-0" dense>
      <v-divider></v-divider>

      <!-- <template v-for="(item, i) in adminMenu">
        <template v-if="!item.children">
          <v-list-item :key="i" @click="routeTo(item.to)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template> -->

      <v-list-group
        v-for="item in adminSubMenu"
        :key="item.title"
        :prepend-icon="item.icon"
        :value="item.active"
      >
        <v-list-item slot="activator" class="pl-0">
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="subItem in item.children"
          :key="subItem.title"
          @click="routeTo(subItem.to)"
        >
          <v-list-item-action>
            <v-icon class="subItem" small>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="subItem2">{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>

      <template v-for="(item, i) in filteredAdminMenu">
        <template v-if="!item.children">
          <v-list-item :key="i" @click="routeTo(item.to)">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { isDev } from '@/utils/helpers';

export default {
  name: 'AppAdminNavDrawer',
  props: {
    me: {
      type: Object,
      required: true,
    },
    isAdmin: {
      type: Boolean,
      required: true,
    },
    drawer: {
      type: Boolean,
      required: true,
      default: false,
    },
    canViewAdmin: {
      type: Boolean,
      default: false,
    },
    limitedUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isDev,
      lazyProfileImage:
        'https://e6golf-qa-assets.imgix.net/shared/player-art/chipped.jpg?h=200&w=200&fit=crop',
    };
  },

  computed: {
    adminMenu() {
      let menu = [];
      // const meID = this.getMe?.id ? this.getMe.id : undefined;

      menu = [
        {
          title: 'Metrics',
          icon: 'trending_up',
          to: '/admin/metrics',
          children: [
            { title: 'Metrics Dashboard', icon: 'trending_up', to: '/admin/metrics' },
            { title: 'Shots Per Club', icon: 'golf_course', to: '/admin/metrics/club-type' },
            {
              title: 'Shots Per Tracking System',
              icon: 'adjust',
              to: '/admin/metrics/tracking-systems',
            },
            { title: 'User Metrics', icon: 'person', to: '/admin/metrics/users' },
            { title: 'Shot Metrics', icon: 'group_work', to: '/admin/metrics/shots' },
            {
              title: 'Practice Area Metrics',
              icon: 'grass',
              to: '/admin/metrics/practice-areas',
            },
            { title: 'Course Metrics', icon: 'sports_golf', to: '/admin/metrics/courses' },
            { title: 'Game Mode Metrics', icon: 'vibration', to: '/admin/metrics/game-modes' },
          ],
        },
        {
          title: 'Licenses',
          icon: 'local_play',
          children: [
            {
              title: 'User License Management',
              icon: 'badge',
              to: '/admin/license-management',
            },
            { title: 'Add Product to License', icon: 'library_add', to: '/admin/add-product' },
            { title: 'Add New User License', icon: 'add_card', to: '/admin/license-create' },
            { title: 'License Query', icon: 'local_play', to: '/admin/license-query' },
          ],
        },
        {
          title: 'Accounting',
          icon: 'paid',
          children: [
            { title: 'Sales Data', icon: 'shopping_bag', to: '/admin/sales-data' },
            { title: 'Transactions', icon: 'receipt_long', to: '/admin/transactions' },
            { title: 'Quarterly Report', icon: 'assignment', to: '/admin/quarterly-report' },
            {
              title: 'Partner Product Key Report',
              icon: 'handshake',
              to: '/admin/productkeys/report',
            },
          ],
        },
        {
          title: 'Marketing',
          icon: 'work',
          children: [
            {
              title: 'License Redemptions',
              icon: 'receipt',
              to: '/admin/license-redemptions',
            },
            {
              title: 'Expiring Subscriptions',
              icon: 'subscriptions',
              to: '/admin/expiring-subscriptions',
            },
          ],
        },
        {
          title: 'Product Management',
          icon: 'inventory_2',
          children: [
            { title: 'Products', icon: 'inventory_2', to: '/admin/products' },
            { title: 'Bundles', icon: 'workspaces', to: '/admin/bundles' },
            { title: 'Product Keys', icon: 'vpn_key', to: '/admin/product-keys' },
            { title: 'Product Boards (iOS)', icon: 'grid_view', to: '/admin/boards' },
          ],
        },
        {
          title: 'Clubhouses',
          icon: 'sports_golf',
          children: [
            { title: 'Clubhouses', icon: 'groups', to: '/admin/clubhouses' },
            { title: 'Clubhouse Licenses', icon: 'local_play', to: '/admin/clubhouse-licenses' },
            { title: 'Clubhouse Members', icon: 'manage_accounts', to: '/admin/clubhouse-members' },
          ],
        },
        {
          title: 'Permissions',
          icon: 'admin_panel_settings',
          children: [
            {
              title: 'Game Modes',
              icon: 'extension',
              to: '/admin/game_modes',
            },
            {
              title: 'Simulator Permissions',
              icon: 'task_alt',
              to: '/admin/simulator_permissions',
            },
            {
              title: 'Tracking Systems',
              icon: 'assessment',
              to: '/admin/tracking_systems',
            },
          ],
        },
        // {
        //   title: 'Courses',
        //   icon: 'golf_course',
        //   children: [
        //     {
        //       title: 'Courses',
        //       icon: 'sports_golf',
        //       to: '/admin/courses',
        //     },
        //   ],
        // },
        // {
        //   title: 'Product Boards',
        //   icon: 'grid_view',
        //   children: [
        //     {
        //       title: 'Boards',
        //       icon: 'grid_view',
        //       to: '/admin/boards',
        //     },
        //   ],
        // },
        {
          title: 'Users',
          icon: 'account_circle',
          to: '/admin/users',
          // children: [{ title: 'Users', icon: 'groups', to: '/admin/users' }],
        },
        {
          title: 'Courses',
          icon: 'golf_course',
          to: '/admin/courses',
        },
        {
          title: 'Challenges',
          icon: 'auto_awesome',
          to: '/admin/challenges',
        },
        {
          title: 'Events',
          icon: 'emoji_events',
          to: '/admin/events',
        },
        {
          title: 'Game Versions',
          icon: 'source',
          to: '/admin/game_versions',
        },
        {
          title: 'Game Client Downloads',
          icon: 'download_for_offline',
          to: '/admin/game_downloads',
        },
        {
          title: 'Admin Logs',
          icon: 'checklist',
          to: '/admin/logs',
        },
        {
          title: 'Partners',
          icon: 'handshake',
          to: '/admin/partners',
          // children: [
          //   {
          //     title: 'API Keys',
          //     icon: 'api',
          //     to: '/admin/partners',
          //   },
          // ],
        },
        {
          title: 'TruSim API',
          icon: 'api',
          to: '/admin/trusimapi_partners',
          stgOnly: false,
          // children: [
          //   {
          //     title: 'API Keys',
          //     icon: 'api',
          //     to: '/admin/trusimapi_partners',
          //   },
          // ],
        },
        {
          title: 'Legal Agreements',
          icon: 'description',
          to: '/admin/legal-agreements',
          stgOnly: false,
        },
        {
          title: 'AI Commentary',
          icon: 'smart_toy',
          to: '/admin/ai-commentary',
          stgOnly: false,
          // children: [
          //   {
          //     title: 'API Keys',
          //     icon: 'api',
          //     to: '/admin/trusimapi_partners',
          //   },
          // ],
        },
        {
          title: 'API Reference',
          icon: 'api',
          to: '/admin/api-reference',
          stgOnly: false,
        },
        {
          title: 'Scheduler API',
          icon: 'schedule',
          to: '/admin/scheduler-api',
          stgOnly: false,
        },
        {
          title: 'Customer Feedback',
          icon: 'feedback',
          to: '/admin/customer-feedback',
        },
        // {
        //   title: 'Documentation',
        //   icon: 'description',
        //   to: '/admin/documentation',
        // },
      ].filter((item) => {
        if (this.isDev()) {
          return item;
        }
        if (!item.stgOnly) {
          return item;
        }
      });

      return menu;
    },

    filteredAdminMenu() {
      return this.adminMenu.filter((item) => {
        return item !== null && item?.to !== undefined;
      });
    },

    adminSubMenu() {
      return this.adminMenu?.filter((item) => {
        return item !== null && item?.children;
      });
    },

    profileImage() {
      return this.me?.profileImage ? this.me?.profileImage : '';
    },

    displayName() {
      return this.me?.displayName ? this.me?.displayName : '';
    },

    adminDrawer: {
      get() {
        return this.drawer;
      },
      set(val) {
        return val;
      },
    },
  },

  methods: {
    routeTo(data) {
      this.$emit('routeTo', data);
    },

    changeAdmin() {
      this.$emit('changeAdmin');
    },
  },
};
</script>

<style scoped>
.admin-drawer {
  width: 300px !important;
}
.subItem2 {
  margin-left: 10px;
}
</style>
